module.exports = "<p>\n  thread-messages works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/chat/sub-components/thread-messages/thread-messages.component.html
// module id = ./src/app/pages/chat/sub-components/thread-messages/thread-messages.component.html
// module chunks = main